export default __webpack_public_path__ + "static/media/master-card.b04b69af.svg";